/** Help's common questions (L1): each opens the chat's own checked answer, asked as if typed. */
export const HELP_QUESTIONS = ['due_dates', 'late_fee', 'nil_return', 'evc_dsc'] as const;
export type HelpQuestion = (typeof HELP_QUESTIONS)[number];
